import { render, staticRenderFns } from "./purifierWashManage.vue?vue&type=template&id=b712e71e&scoped=true"
import script from "./purifierWashManage.vue?vue&type=script&lang=js"
export * from "./purifierWashManage.vue?vue&type=script&lang=js"
import style0 from "./purifierWashManage.vue?vue&type=style&index=0&id=b712e71e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b712e71e",
  null
  
)

export default component.exports